import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Twitter, Linkedin, Instagram, Github, Send, MessageCircle, BadgeCheck } from 'lucide-react';
import styles from '../../styles/components/Footer.module.css';

const Footer = () => {
  const year = new Date().getFullYear();

  const links = {
    Platform: [
      { to: '/internships', label: 'Browse Internships' },
      { to: '/help', label: 'Help Center' },
      { to: '/verify', label: 'Verify Certificate' },
      { to: '/about', label: 'About Us' },
      { to: '/contact', label: 'Contact' },
    ],
    Internships: [
      { to: '/internships?category=Web Development', label: 'Web Development' },
      { to: '/internships?category=Python Programming', label: 'Python Programming' },
      { to: '/internships?category=Data Analytics', label: 'Data Analytics' },
      { to: '/internships?category=AI Tools', label: 'AI Tools' },
      { to: '/internships?category=UI/UX Design', label: 'UI/UX Design' },
      { to: '/internships?category=Digital Marketing', label: 'Digital Marketing' },
    ],
    Legal: [
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms & Conditions' },
      { to: '/refund', label: 'Refund Policy' },
      { to: '/disclaimer', label: 'Disclaimer' },
    ],
  };

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.grid}>
          {/* Brand */}
          <div className={styles.brand}>
            <div className={styles.logoRow}>
              <img src="/logo.png" alt="GetNextern" className={styles.logoImg} />
            </div>
            <p className={styles.tagline}>
              A project-based internship platform where students learn, build real projects, and earn verifiable certificates.
            </p>
            <div className={styles.socials}>
              {[
                { icon: <Twitter size={18} />, href: process.env.REACT_APP_TWITTER_URL || null, label: 'Twitter' },
                { icon: <Linkedin size={18} />, href: 'https://www.linkedin.com/company/getnextern/', label: 'LinkedIn' },
                { icon: <Instagram size={18} />, href: 'https://www.instagram.com/getnextern/', label: 'Instagram' },
                { icon: <Github size={18} />, href: 'https://github.com/GetNextern/.github', label: 'GitHub' },
                { icon: <Send size={18} />, href: 'https://t.me/getnextern', label: 'Telegram' },
                { icon: <MessageCircle size={18} />, href: 'https://whatsapp.com/channel/0029VbCoPKFH5JLxlq0ekU1Z', label: 'WhatsApp' },
              ].filter(s => s.href).map((s, i) => (
                <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className={styles.socialBtn}>
                  {s.icon}
                </a>
              ))}
            </div>

            <div className={styles.contactList}>
              <div className={styles.contactItem}>
                <Mail size={14} /> <span>support@getnextern.xyz</span>
              </div>
              <div className={styles.contactItem}>
                <Mail size={14} /> <span>hellouser@getnextern.xyz</span>
              </div>
              <div className={styles.contactItem}>
                <MapPin size={14} /> <span>India</span>
              </div>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(links).map(([heading, items]) => (
            <div key={heading} className={styles.column}>
              <h4 className={styles.columnHeading}>{heading}</h4>
              <ul className={styles.linkList}>
                {items.map(item => (
                  <li key={item.to}>
                    <Link to={item.to} className={styles.link}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* MSME Registration Info */}
        <div className={styles.msmeBar}>
          <div className={styles.msmeLeft}>
            <div className={styles.msmeIcon}>
              <BadgeCheck size={16} />
            </div>
            <div className={styles.msmeText}>
              <span className={styles.msmeLabel}>Registered Micro Enterprise (MSME)</span>
              <span className={styles.msmeDivider}>|</span>
              <span className={styles.msmeNumber}>Udyam Registration No.: UDYAM-KR-05-0064790</span>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className={styles.disclaimer}>
          <p className={styles.disclaimerText}>
            ⚠️ <strong className={styles.disclaimerBold}>Disclaimer:</strong> GetNextern certificates are issued upon project completion and are not affiliated with any government body, university, or statutory authority. These are platform-issued certificates recognizing your learning and project work. No false employment or government affiliation claims are made.
          </p>
        </div>

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            © {year} GetNextern. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;